import React, { useCallback } from 'react'
import { Dialog } from '@yanolja-rnd/nol-design-system'
import { useDomesticCartDelete } from '~/app/components-nds/domestic/cart/hooks/use-domestic-cart-delete'
import { zIndexMax } from '~/app/components/styles/units'

interface DeleteConfirmDialogProps {
  /** 다이얼로그 표시 여부 */
  isOpen: boolean
  /** 다이얼로그 닫기 핸들러 */
  onClose: () => void
  /** 삭제할 옵션 ID */
  optionId: string
}

/**
 * 삭제 확인 다이얼로그 공용 컴포넌트
 */
const DeleteConfirmDialog: React.FC<DeleteConfirmDialogProps> = ({ isOpen, onClose, optionId }) => {
  const { deleteCartOptions } = useDomesticCartDelete()

  const handleDeleteConfirm = useCallback(() => {
    onClose()
    deleteCartOptions([optionId])
  }, [deleteCartOptions, optionId, onClose])

  return (
    <Dialog
      show={isOpen}
      title={'선택한 상품을 삭제할까요?'}
      negativeButton={{
        text: '아니요',
        onClick: onClose,
      }}
      positiveButton={{
        text: '삭제하기',
        onClick: handleDeleteConfirm,
      }}
      zIndex={zIndexMax}
    />
  )
}

export default DeleteConfirmDialog
